import React from 'react'
import CustomFieldItem from './CustomFieldItem';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities'; 
import styles from './Styles.module.scss';

export default function DraggableFieldsView(props) {
  const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id:props.item.id });
  
  const style = {
    transform: transform ?  CSS.Transform.toString(transform):undefined,
    transition,
  };
 
  return (
   

    <div ref={setNodeRef} style={style} 
    {...attributes} 
    {...listeners}
    
    >

      {/* <div onClick={() => props.onSelection(props.item)}> */}
      <CustomFieldItem
        key={props.item.id}
        // className={isDragging ? styles.dragging : null}
        index={props.index}
        item={props.item}
        onChange={props.onChange}
        onDelete={props.onDelete}
        onSelection={props.onSelection}
        selected = {props.selected}
      />
    <div className={styles.line}></div>

      </div>
  );
}






